import { Vue } from 'vue-class-component';
import { Inject, Options, Ref } from 'vue-property-decorator';
import ApplicationMenu from '@/components/header/application-menu/index.vue';
import { RouteN } from '@/constants/route-name';
import { AuthorizedUser } from '@/models/authorized-user';
import { EventEmitter } from 'events';

@Options<AccountInfoPanel>({
  components: {
    ApplicationMenu
  }
})
export default class AccountInfoPanel extends Vue {

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  @Ref('dropDownMenu')
  private dropDownMenuUI!: HTMLElement;

  public showMenu = false;

  created(): void {
    window.addEventListener('click', this.clickedElement);
  }

  beforeUnmount(): void {
    window.removeEventListener('click', this.clickedElement);
  }

  private clickedElement(e: MouseEvent): void | boolean {
    const el: HTMLElement = this.dropDownMenuUI as HTMLElement;
    const elBut: HTMLElement = this.dropDownMenuUI as HTMLElement;
    const target: HTMLElement = e.target as HTMLElement;
    if (el !== target && elBut !== target) {
      this.showMenu = false;
    }
  }

  get isConfirmationPage(): boolean{
    const section: string = this.$route.query.sec as string || '';
    return section.indexOf('confirmation') > -1;
  }

  private onMenuClicked() {
    switch (this.$route.name) {
      case RouteN.CMP.Dashboard.n:
        this.showMenu = !this.showMenu;
        break;
      case RouteN.CMP.EoiApply.n:
        this.cancelAppClick();
        break;
      default:
        this.$router.push({ name: RouteN.CMP.Dashboard.n });
        break;
    }
  }

  get infoTextRow0(): string {
    return this.userAccount.user.firstName + ' ' + this.userAccount.user.lastName;
  }


  get menuButtonText(): string {
    switch (this.$route.name) {
      case RouteN.CMP.Dashboard.n:
        return 'My Account';
      case RouteN.CMP.EoiApply.n:
        return this.isConfirmationPage ? 'Close' : 'Cancel Application';
      default:
        return 'Close';
    }
  }


  get menuIcon(): string {
    switch (this.$route.name) {
      case RouteN.CMP.Dashboard.n:
        return this.showMenu ? 'fa-times' : 'fa-bars';
      default:
        return 'fa-times';
    }
  }

  public cancelAppClick(): void {
    switch (this.$route.name) {
      case RouteN.CMP.EoiApply.n:
        this.eventCtrl.emit('cancel-eoi-apply-clicked');
        break;
      default:
        break;
    }
  }

  get userAccount(): AuthorizedUser {
    return this.$store.getters.getUserAccount;
  }

}
